import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import {
    fetchAppointmentAPI,
    updateAppointmentAPI,
} from '@/components/fakeDoor/api';
import { IAppointmentData } from '@/components/fakeDoor/types';

interface AppointmentState {
    data: any | null;
    loading: boolean;
    error: string | null;
}

const initialState: AppointmentState = {
    data: null,
    loading: false,
    error: null,
};

// Async thunk for the API call
export const updateAppointment = createAsyncThunk(
    'appointment/update',
    async (appointmentData: IAppointmentData, { rejectWithValue }) => {
        try {
            const result = await updateAppointmentAPI(appointmentData);
            console.log('Post appointment call result', result);
            return result;
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchAppointment = createAsyncThunk(
    'appointment/fetch',
    async (appointmentId: string, { rejectWithValue }) => {
        try {
            const result = await fetchAppointmentAPI(appointmentId);
            return result;
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

const appointmentSliceV2 = createSlice({
    name: 'appointment',
    initialState,
    reducers: {
        // Action to update state from outside
        setAppointmentData(state, action: PayloadAction<any>) {
            state.data = action.payload;
        },
        resetAppointmentState(state) {
            state.data = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateAppointment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                updateAppointment.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.loading = false;
                    state.data = action.payload;
                }
            )
            .addCase(
                updateAppointment.rejected,
                (state, action: PayloadAction<any>) => {
                    state.loading = false;
                    state.error = action.payload || 'An error occurred';
                }
            )
            .addCase(fetchAppointment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(
                fetchAppointment.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.loading = false;
                    state.data = action.payload;
                }
            )
            .addCase(
                fetchAppointment.rejected,
                (state, action: PayloadAction<any>) => {
                    state.loading = false;
                    state.error = action.payload || 'An error occurred';
                }
            );
    },
});

export const { setAppointmentData, resetAppointmentState } =
    appointmentSliceV2.actions;

export const selectBookingData = (state: any) => state.bookingData;

export default appointmentSliceV2.reducer;
